import * as React from 'react';
import { styled, useThemeProps } from '@mui/material/styles';

const DivRoot = styled('div', {
  name: 'MuiZBox',
  slot: 'root',
})(({ theme }) => ({
  
}));

const DivContainer = React.forwardRef(function DivContainer(inProps, ref) {
  const props = useThemeProps({ props: inProps, name: 'MuiZBox' });
  const { variant, ...other } = props;

  const ownerState = { ...props, variant };
  return (
    <DivRoot ref={ref} ownerState={ownerState} {...other}>
      {props.children}
    </DivRoot>
  );
});

export default function ZBox(props) {
  return (
    <DivContainer sx={props?.sx} className={props?.className} {...props}>
      {props?.children}
    </DivContainer>
  );
}
